const KLAVIYO_API_KEY = 'HteeMZ'

interface Attributes {
  list_id: string
  custom_source?: string
  email?: string
  phone_number?: string
  properties?: Record<string, string | string[]>
}
export async function subscribe(attributes: Attributes) {
  return await fetch(
    `https://a.klaviyo.com/client/subscriptions/?company_id=${KLAVIYO_API_KEY}`,
    {
      method: 'POST',
      headers: {
        revision: '2025-01-15',
        'content-type': 'application/json',
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: attributes.custom_source,
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: attributes.email,
                  phone_number: attributes.phone_number,
                  properties: attributes.properties,
                },
              },
            },
          },
          relationships: {
            list: {
              data: { type: 'list', id: attributes.list_id },
            },
          },
        },
      }),
    },
  )
}
